import React, { useState, useEffect } from 'react'
import axiosJWT from '../../JwtToken'

export const PreviewPKS = ({ rowID, getPesan, setMsg, closePKS }) => {
    const [formData, setFormData] = useState({})

    useEffect(() => {
        const fetchPKS = async () => {
            try {
                // Ambil data PKS berdasarkan ID (rowID)
                const response = await axiosJWT.get(`/api/pks/preview/${rowID}`)
                setFormData(response.data)
            } catch (err) {
                getPesan()
                setMsg("Gagal memuat data PKS.")
                setTimeout(() => {
                    getPesan()
                    setMsg("")
                }, 2000)
            }
        }
        fetchPKS()
    }, [rowID])

    if (!formData || !formData.pihak1 || !formData.pihak2) {
        return <div>Memuat dokumen...</div>
    }

    const numberToWords = (num) => {
        const units = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"]

        if (num < 12) return units[num]
        if (num < 20) return units[num % 10] + " Belas"
        if (num < 100) return units[Math.floor(num / 10)] + " Puluh " + units[num % 10]
        if (num < 200) return "Seratus " + numberToWords(num % 100)
        if (num < 1000) return units[Math.floor(num / 100)] + " Ratus " + numberToWords(num % 100)
        if (num < 2000) return "Seribu " + numberToWords(num % 1000)
        if (num < 10000) return units[Math.floor(num / 1000)] + " Ribu " + numberToWords(num % 1000)
        return num.toString()
    }

    const getIndonesianDate = () => {
        const d = new Date()
        const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
        const months = [
            "Januari", "Februari", "Maret", "April", "Mei", "Juni",
            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ]

        const dayName = days[d.getDay()]
        const date = numberToWords(d.getDate())
        const monthName = months[d.getMonth()]
        const yearWords = numberToWords(d.getFullYear())

        return {
            dayName,
            date,
            monthName,
            yearWords,
            fullDateStr: `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`
        }
    }

    const dateInfo = getIndonesianDate()

    const formatTanggal = (isoDate) => {
        if (!isoDate) return '........'

        const date = new Date(isoDate)
        const months = [
            "Januari", "Februari", "Maret", "April", "Mei", "Juni",
            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ]

        const d = date.getDate()
        const m = months[date.getMonth()]
        const y = date.getFullYear()

        return `${d} ${m} ${y}`
    }

    const formatJudulPengadaan = (input) => {
        if (!input) return ""
        
        // 1. Ubah ke uppercase
        let clean = input.toUpperCase()
        
        // 2. Hapus kata "PENGADAAN " kalau ada di depan
        clean = clean.replace(/^PENGADAAN\s+/i, '')
        
        // 3. Gabungkan dengan kata PENGADAAN yang sudah fix (biar gak double)
        return `PENGADAAN ${clean}`
    }

    const getNamaIdentitas = (pihak) => {
        if (pihak.jenis === 'Perorangan') {
            return pihak.nm_usaha || 'Nama Usaha Tidak Ditemukan'
        }
        // Jika Badan Usaha
        return `${pihak.jns_badan || ''}. ${pihak.nm_badan_usaha || ''}`
    }

    // 2. Gunakan fungsi helper yang tadi kita buat untuk render pihak
    const renderPihak = (pihak, jabatanManual) => {
        return (
            <td>
                <b>
                    {pihak.jenis === 'Perorangan'
                        ? ''
                        : `${pihak.jns_badan || ''}. ${pihak.nm_badan_usaha || ''}`}
                </b>

                {pihak.jenis === 'Perorangan' && (
                    <>Beralamat di {pihak.alamat} RT. {pihak.no_rt} RW. {pihak.no_rw}</>
                )}

                {pihak.jenis === 'BadanUsaha' && (
                    <>, beralamat di {pihak.alamat} RT. {pihak.no_rt} RW. {pihak.no_rw}</>
                )}

                , Kel. {pihak.nama_kel}, Kec. {pihak.nama_kec}
                , {pihak.nama_kab}, {pihak.nama_prop}

                {pihak.jenis === 'BadanUsaha' && (
                    <>, selaku <b>{jabatanManual}</b>, dengan Nomor Induk Berusaha: <b>{pihak.nib}</b>, selanjutnya disebut <b>PIHAK KESATU</b></>
                )}

                {pihak.jenis === 'Perorangan' && (
                    <>, Pemilik UMKM <b>{pihak.nm_usaha}</b> dengan Nomor Induk Berusaha: <b>{pihak.nib}</b>, selanjutnya disebut <b>PIHAK KEDUA</b></>
                )}
            </td>
        )
    }

    return (<>
        <div className='modal-body-pks'>
            <div className="pks-paper-container">
                <div className="pks-wrapper">
                    <div className="pks-document">
                        {/* JUDUL */}

                        <div className="header-box-pks">
                            <div className="title-pks">PERJANJIAN KERJA SAMA</div>
                            <div className="subtitle-pks">ANTARA</div>
                            <div className="subtitle-pks">{getNamaIdentitas(formData.pihak1).toUpperCase()}</div>
                            <div className="subtitle-pks">DENGAN</div>
                            <div className="subtitle-pks">{getNamaIdentitas(formData.pihak2).toUpperCase()}</div>
                            <div className="nomor-pks font-bold">NOMOR: ..........................</div>
                            <div className="subtitle-pks">{formatJudulPengadaan(formData.namaBarangJasa)}</div>
                        </div>

                        <p className='justify'>
                            Pada hari ini <b>{dateInfo.dayName}</b> tanggal <b>{dateInfo.date}</b> bulan <b>{dateInfo.monthName}</b> tahun <b>{dateInfo.yearWords}</b> (<b>{dateInfo.fullDateStr}</b>), kami yang bertanda tangan di bawah ini:
                        </p>

                        {/* PIHAK KESATU & KEDUA */}
                        <table className="table-pihak-pks">
                            <tr>
                                <td className="col-no-pks">1.</td>
                                <td className="col-identitas-pks">
                                    <b>{formData.namaPenandatanganPihak1}</b>
                                </td>
                                <td className="col-pemisah-pks">:</td>
                                {renderPihak(formData.pihak1, formData.jabatanPihak1)}
                            </tr>
                            <tr>
                                <td className="col-no-pks">2.</td>
                                <td className="col-identitas-pks">
                                    <b>{formData.namaPenandatanganPihak2}</b>
                                </td>
                                <td className="col-pemisah-pks">:</td>
                                {renderPihak(formData.pihak2, formData.jabatanPihak2)}
                            </tr>
                        </table>

                        <p className='justify'>
                            <b>PIHAK KESATU</b> dan <b>PIHAK KEDUA</b> yang selanjutnya disebut <b>PARA PIHAK</b> sepakat untuk mengadakan <b>Perjanjian Kerja Sama Pengadaan Barang dan Jasa UMKM</b> dengan ketentuan sebagai berikut:
                        </p>

                        <div className="section-title-pks">PASAL 1<br />MAKSUD DAN TUJUAN</div>

                        <table className="table-list-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Perjanjian ini dimaksudkan sebagai dasar kerja sama pengadaan barang berupa produk UMKM.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Tujuan Perjanjian ini adalah untuk memenuhi kebutuhan barang <b>PIHAK KESATU</b> serta mendukung pemasaran dan pemberdayaan produk <b>UMKM PIHAK KEDUA</b>.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(3)</td>
                                <td className="col-content-pks">Melaksanakan ketentuan pasal 19 ayat (1) dan ayat (2) Peraturan Daerah Kota Bekasi nomor 14 tahun 2023 tentang Penyelenggaraan Penanaman Modal.</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 2<br />RUANG LINGKUP KERJA SAMA</div>

                        <table className="table-list-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Ruang lingkup kerja sama meliputi penyediaan, penyerahan, dan penerimaan barang produk UMKM.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Jenis dan spesifikasi barang sebagaimana dimaksud pada ayat (1) ditetapkan berdasarkan kesepakatan Para Pihak.</td>
                            </tr>
                        </table>
                    </div>

                    <div className="page-break-pks"></div>

                    <div className="pks-document">

                        <div className="section-title-pks">PASAL 3<br />JENIS DAN SPESIFIKASI BARANG</div>

                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td colspan="4">Jenis barang yang disediakan <b>PIHAK KEDUA</b> meliputi:</td>
                            </tr>

                            <tr>
                                <td></td>
                                <td className="col-sub-pks">a)</td>
                                <td className="col-label-pks">Nama Barang</td>
                                <td className="col-sep-pks">:</td>
                                <td>.......................</td>
                            </tr>

                            <tr>
                                <td></td>
                                <td className="col-sub-pks">b)</td>
                                <td className="col-label-pks">Spesifikasi</td>
                                <td className="col-sep-pks">:</td>
                                <td>.......................</td>
                            </tr>

                            <tr>
                                <td></td>
                                <td className="col-sub-pks">c)</td>
                                <td className="col-label-pks">Standar Mutu</td>
                                <td className="col-sep-pks">:</td>
                                <td>.......................</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td colspan="4">Rincian spesifikasi, jumlah, dan harga barang dicantumkan dalam <b>Lampiran I</b> dan/atau Purchase Order (PO) yang merupakan bagian tidak terpisahkan dari Perjanjian ini.</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 4<br />JENIS KONTRAK DAN HUBUNGAN HUKUM</div>

                        <table className="table-list-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Perjanjian ini merupakan <b>Perjanjian Kerja Sama Pengadaan Barang Sederhana</b>;</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Hubungan hukum Para Pihak adalah hubungan kemitraan dan tidak menimbulkan hubungan kepegawaian, keagenan, atau perwakilan.</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 5<br />PELAKSANAAN KONTRAK</div>

                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Pelaksanaan Perjanjian ini dilakukan sesuai ketentuan dalam Perjanjian dan dokumen pelaksanaannya.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Pengadaan barang dilaksanakan berdasarkan kebutuhan <b>PIHAK KESATU</b> melalui penerbitan surat pemesanan atau Purchase Order (PO).</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(3)</td>
                                <td className="col-content-pks">Setiap PO sekurang-kurangnya memuat jenis barang, spesifikasi, jumlah, harga, waktu, dan tempat penyerahan.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(4)</td>
                                <td className="col-content-pks">PO merupakan bagian yang tidak terpisahkan dari Perjanjian ini.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(5)</td>
                                <td className="col-content-pks"><b>PIHAK KEDUA</b> wajib melaksanakan pengadaan sesuai PO yang diterbitkan <b>PIHAK KESATU</b>.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(6)</td>
                                <td className="col-content-pks">Penyerahan barang dapat dilakukan secara bertahap atau sekaligus sesuai PO.</td>
                            </tr>
                        </table>
                    </div>

                    <div className="page-break-pks"></div>

                    <div className="pks-document">

                        <div className="section-title-pks">PASAL 6<br />HARGA DAN CARA PEMBAYARAN</div>

                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Penyerahan barang pesanan dan peralihan resiko atas serah terima barang yang dilakukan, diatur dalam purchasing order yang dilakukan oleh <b>PARA PIHAK</b>.</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 7<br />HAK DAN KEWAJIBAN</div>

                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td colspan="2">Hak <b>PIHAK KESATU</b>:</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">a.</td>
                                <td>Mendapatkan informasi yang benar, jelas, dan jujur mengenai kondisi dan jaminan barang dan/atau jasa dari <b>PIHAK KEDUA</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">b.</td>
                                <td>Mendapatkan  barang dan/atau jasa yang sesuai dengan Permintaan/ Pesanan/ PO  dari <b>PIHAK KEDUA</b>;</td>
                            </tr>
                            <tr>
                                <td colspan="3" className="pt-1"></td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td colspan="2">Hak <b>PIHAK KEDUA</b>:</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">a.</td>
                                <td>Mendapatkan Invoice Pembayaran atas barang/ Jasa yang diterima dari <b>PIHAK KEDUA</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">b.</td>
                                <td>Mendapatkan kompensasi, ganti rugi dan/atau penggantian, apabila barang dan/atau jasa yang diterima tidak sesuai dengan perjanjian atau tidak sebagaimana mestinya;</td>
                            </tr>
                            <tr>
                                <td colspan="3" className="pt-1"></td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(3)</td>
                                <td colspan="2">Kewajiban <b>PIHAK KESATU</b>:</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">a.</td>
                                <td>Menyampaikan surat pemesanan/permintaan/ PO atas barang / jasa  yang diinginkan dari <b>PIHAK KESATU</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">b.</td>
                                <td>Melakukan pembayaran  atas barang / Jasa yang diterima dari <b>PIHAK KEDUA</b> sesuai dengan  harga yang disepakati kepada <b>PIHAK KEDUA</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">c.</td>
                                <td>Menerima surat pemesanan/ permintaan/ PO atas barang / jasa  yang diinginkan dari <b>PIHAK KESATU</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">d.</td>
                                <td>Menerima pembayaran yang sesuai dengan kesepakatan mengenai kondisi dan nilai tukar barang dan/atau jasa yang diperdagangkan;</td>
                            </tr>
                            <tr>
                                <td colspan="3" className="pt-1"></td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(4)</td>
                                <td colspan="2">Kewajiban <b>PIHAK KEDUA</b>:</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">a.</td>
                                <td>Memberikan  informasi yang benar, jelas, dan jujur mengenai kondisi dan jaminan barang dan/atau jasa kepada <b>PIHAK KESATU</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">b.</td>
                                <td>Memberikan barang dan/atau jasa yang sesuai dengan Permintaan/ Pesanan/ PO  kepada <b>PIHAK KESATU</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">c.</td>
                                <td>Menyampaikan  Invoice Pembayaran atas barang/ Jasa yang diberikan kepada <b>PIHAK KESATU</b>;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">d.</td>
                                <td>Memberikan kompensasi, ganti rugi dan/atau penggantian, apabila barang dan/atau jasa yang diterima tidak sesuai dengan perjanjian atau tidak sebagaimana mestinya kepada <b>PIHAK KESATU</b>;</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 8<br />SERAH TERIMA DAN PERALIHAN RISIKO</div>
                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Menyediakan dan menyerahkan barang sesuai PO.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Menjamin mutu dan keaslian produk UMKM.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(3)</td>
                                <td className="col-content-pks">Bertanggung jawab atas cacat barang dalam jangka waktu <b>{formData.masaCacatHari ? formData.masaCacatHari : '___'}</b> hari sejak serah terima.</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 9<br />JANGKA WAKTU DAN MASA BERLAKU</div>
                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">
                                    Perjanjian ini berlaku selama <b>{formData.durasiKontrak || '___'}</b> sejak tanggal <b>{formatTanggal(formData.tanggalMulai)}</b> sampai dengan <b>{formatTanggal(formData.tanggalSelesai)}</b>.
                                </td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Perjanjian dapat diperpanjang berdasarkan kesepakatan tertulis Para Pihak.</td>
                            </tr>
                        </table>

                    </div>

                    <div className="page-break-pks"></div>

                    <div className="pks-document">
                        <div className="section-title-pks">PASAL 10<br />ADDENDUM</div>
                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Setiap perubahan atau penambahan Perjanjian ini hanya sah apabila dibuat secara tertulis dalam bentuk Adendum.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Adendum merupakan bagian tidak terpisahkan dari Perjanjian ini.</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 11<br />PENGAKHIRAN PERJANJIAN</div>
                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Perjanjian dapat diakhiri berdasarkan kesepakatan Para Pihak;</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Salah satu Pihak berhak mengakhiri Perjanjian apabila Pihak lainnya wanprestasi.</td>
                            </tr>
                        </table>

                        <div className="section-title-pks">PASAL 12<br />KEADAAN MEMAKSA (FORCE MAJEURE)</div>
                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td colspan="2">Yang dimaksud keadaan memaksa (force majeure) dalam perjanjian ini adalah peristiwa-peristiwa yang berada di luar kemampuan <b>PARA PIHAK</b> yang berakibat tidak dapat dipenuhinya kewajiban-kewajiban <b>PARA PIHAK</b>, antara lain:</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">a.</td>
                                <td>gempa bumi besar;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">b.</td>
                                <td>angin ribut/angin topan;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">c.</td>
                                <td>banjir besar;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">d.</td>
                                <td>kebakaran besar;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">e.</td>
                                <td>tanah longsor;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">f.</td>
                                <td>wabah penyakit;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">g.</td>
                                <td>pemogokan umum;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">h.</td>
                                <td>huru-hara;</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">i.</td>
                                <td>sabotase; dan</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className="col-sub-pks">j.</td>
                                <td>perang dan pemberontakan sehingga tidak dapat dilaksanakannya perjanjian ini.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td colspan="2">Apabila terjadi (force majeure) sebagaimana dimaksud pada ayat (1), maka berlaku ketentuan sebagaimana dimaksud dalam Pasal 8 ayat (2).</td>
                            </tr>
                        </table>

                    </div>

                    <div className="page-break-pks"></div>

                    <div className="pks-document">
                        <div className="section-title-pks">PASAL 13<br />KETENTUAN PENUTUP</div>
                        <table className="table-pasal-pks">
                            <tr>
                                <td className="col-num-pks">(1)</td>
                                <td className="col-content-pks">Perjanjian ini mengikat <b>PARA PIHAK</b> sejak ditandatangani.</td>
                            </tr>
                            <tr>
                                <td className="col-num-pks">(2)</td>
                                <td className="col-content-pks">Hal-hal yang belum cukup dan/atau diatur dalam Perjanjian ini akan diatur dalam Perjanjian tambahan (addendum) dan merupakan satu kesatuan yang tidak terpisahkan dari perjanjian kerja sama ini.</td>
                            </tr>
                        </table>

                        <p className="justify mt-2">
                            Demikian Perjanjian Kerja Sama ini dibuat oleh <b>PARA PIHAK</b> dan ditandatangani secara langsung, pada hari, tanggal, bulan dan tahun sebagaimana tersebut di atas, dalam rangkap 2 (dua), dan masing-masing mempunyai kekuatan hukum yang sama.
                        </p>
                        <br />

                        <table className="ttd-table-pks">
                            <tr>
                                <td>
                                    <b>PIHAK KEDUA,</b><br /><br /><br /><br />
                                    <span className="name-bold-pks">{formData.namaPenandatanganPihak2}</span><br />
                                    {formData.jabatanPihak2}
                                </td>
                                <td>
                                    <b>PIHAK KESATU,</b><br /><br /><br /><br />
                                    <span className="name-bold-pks">{formData.namaPenandatanganPihak1}</span><br />
                                    {formData.jabatanPihak1}
                                </td>
                            </tr>
                        </table>

                    </div>

                    <div className="page-break-pks"></div>

                    <div className="pks-document">

                        {/* TABEL LAMPIRAN */}
                        <div className="header-box-pks">
                            <div className="title-pks">LAMPIRAN PERJANJIAN KERJA SAMA</div>
                            <div className="nomor-pks font-bold">DETAIL SPESIFIKASI DAN HARGA BARANG</div>
                        </div>

                        <table className="table-barang-pks">
                            <thead>
                                <tr>
                                    <th className="col-num-pks">NO</th>
                                    <th>NAMA BARANG</th>
                                    <th>SPESIFIKASI</th>
                                    <th>SATUAN</th>
                                    <th>HARGA (Rp)</th>
                                    <th>VOLUME</th>
                                    <th>TOTAL (Rp)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formData.detailBarang.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>{item.namaBarang}</td>
                                        <td>{item.spesifikasiTeknis}</td>
                                        <td>{item.satuan}</td>
                                        <td>{item.hargaSatuan.toLocaleString()}</td>
                                        <td>{item.volume}</td>
                                        <td>{item.totalHarga.toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="mt-3">
                            <p>Lampiran ini merupakan bagian yang tidak terpisahkan dari Perjanjian Kerja Sama ini.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="modal-footer">
            <button className="btn btn-raised btn-danger br-2" type="button" onClick={closePKS}><i className="fa fa-sign-out"></i> Tutup</button>
        </div>
    </>)
}